import React from 'react';
import { motion } from 'framer-motion';
export function SocialProof() {
  const testimonials = [{
    name: 'Andrés M.',
    role: 'Consultor',
    result: 'Resultado: +10k seguidores',
    quote: 'Mi retención pasó del 20% al 65% en YouTube usando el Edutainment OS. Los seguidores creen que tengo un equipo de edición detrás, pero soy solo yo y mi laptop.'
  }, {
    name: 'Carla R.',
    role: 'Coach de Salud',
    result: 'Resultado: Ventas Triplicadas',
    quote: 'El sistema me ahorra al menos 15 horas de edición por semana. Mis videos ahora proyectan la autoridad que siempre quise. Es el secreto mejor guardado de mi negocio.'
  }, {
    name: 'Julián G.',
    role: 'Real Estate',
    result: 'Resultado: CPC de $0.80 a $0.15',
    quote: 'Cuando tus videos se ven así de bien, los anuncios se vuelven ridículamente baratos. La gente no puede evitar detener el scroll.'
  }];
  const Star = () => <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 text-gold-500" data-id="element-151">
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-152" />
    </svg>;
  return <section className="py-12 md:py-24 px-4 md:px-6 bg-navy-900" data-id="element-153">
      <div className="max-w-5xl mx-auto" data-id="element-154">
        <div className="text-center mb-8 md:mb-16" data-id="element-155">
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-3 md:mb-4" data-id="element-156">
            Resultados Innegables
          </h2>
          <div className="h-1 w-20 bg-gold-500 mx-auto rounded-full" data-id="element-157"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-8" data-id="element-158">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-navy-800 p-5 md:p-8 rounded-xl border-t-2 border-gold-500/50 shadow-xl relative" data-id="element-159">
              <div className="absolute -top-4 left-6 md:left-8 bg-navy-900 px-2 text-gold-500" data-id="element-160">
                <svg viewBox="0 0 24 24" fill="currentColor" className="w-8 h-8 opacity-50" data-id="element-161">
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-162" />
                </svg>
              </div>

              <div className="flex space-x-1 mb-4 mt-4" data-id="element-163">
                {[...Array(5)].map((_, i) => <Star key={i} data-id="element-164" />)}
              </div>

              <p className="text-gray-300 font-light italic mb-5 md:mb-8 text-sm md:text-base" data-id="element-165">
                "{testimonial.quote}"
              </p>

              <div className="border-t border-white/10 pt-4 md:pt-6" data-id="element-166">
                <p className="font-bold text-white" data-id="element-167">{testimonial.name}</p>
                <p className="text-sm text-gray-400" data-id="element-168">{testimonial.role}</p>
                <p className="text-sm text-gold-500 font-medium mt-2" data-id="element-169">
                  {testimonial.result}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}